import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Area } from 'src/app/shared/models/area';

@Component({
	selector: 'app-area-form',
	templateUrl: './area-form.component.html',
	styleUrls: ['./area-form.component.scss']
})
export class AreaFormComponent {
	@Input() area: Area;
	@Input() isAddForm: boolean;
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };

	MAX_NAME_CHAR = 25;

	constructor() {}

	// ngOnInit(): void {}

	onSubmit(): void {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.area.name = this.form.get('name').value;
			this.area.description = this.form.get('description').value;
			this.sendForm.emit();
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	get name() {
		return this.form?.get('name');
	}
	get description() {
		return this.form?.get('description');
	}
}
